import { useAuth } from '../store/auth';

/**
 * Returns a multiplier to apply to dashboard polling intervals based on the
 * current user's role.
 *
 *   - admin = 1.0   (full speed, ops monitoring use case)
 *   - user  = 2.0   (publishers checking their own data — less time-sensitive,
 *                    they're not doing live ops decisions)
 *   - logged-out = 1.0 (defensive default; usually no polling fires anyway)
 *
 * Usage:
 *   const mult = usePollMultiplier();
 *   refetchInterval: range === 'today' ? 10_000 * mult : false
 *
 * Effect at multi-user scale (50-100 users, mostly publishers):
 *   - 50 publishers polling at 2x slower = same load as 25 polling at full
 *     speed → ~50% reduction in dashboard request rate
 *   - Admin user-experience unchanged
 *
 * Trade-off: publisher dashboards lag ~10s longer in showing fresh data,
 * which is fine for "did my conversion just come in?" use case (they'll
 * see it next refresh, no critical decision depends on sub-10s freshness).
 */
export function usePollMultiplier(): number {
  const role = useAuth((s) => s.user?.role);
  return role === 'user' ? 2 : 1;
}
